import Vue from "vue";
import Router, { RouteConfig } from "vue-router";
// import Home from "./views/Home.vue";
import Profile from "@/views/Profile/profile.view.vue";
import UserConfig from "@/modules/Profile/user-config.vue";
import Login from "@/modules/usuarios/login/login.vue";
import CreateAccountOptions from "@/modules/usuarios/login/createAccountOptions.vue";
import AccessOptions from "@/modules/usuarios/login/accessOptions.vue";
import CreateAccountBeneficario from "@/modules/usuarios/login/createAccountBeneficario.vue";
import CreateAccountNoBeneficario from "@/modules/usuarios/login/createAccountNoBeneficario.vue";
import Acceder from "@/modules/usuarios/login/acceder.vue";
// import ConsultaRapida from "@/modules/usuarios/login/consultaRapida.vue";
import AccederTarjetaSolidaridad from "@/modules/usuarios/login/accederTarjetaSolidaridad.vue";
import ForgotPassword from "@/modules/usuarios/login/forgotPassword.vue";
import PasswordRecovery from "@/modules/usuarios/login/passwordRecovery.vue";
import TramiteCreacion from "@/modules/tramite/creacion.vue";
import TramiteEvaluacion from "@/modules/tramite/tramite-evaluacion-hogar.vue";
import TramiteResumen from "@/modules/tramite/review.vue";

Vue.use(Router);

export class RoutesList {
  static getRoutes(): RouteConfig[] {
    return [
      {
        path: "/",
        name: "Profile",
        component: Profile,
        meta: {
          index: 1,
          icon: "home",
          requiresAuth: true,
          isMobile: true
        }
      },
      {
        path: "/Profile",
        name: "ProfileP",
        component: Profile,
        meta: {
          requiresAuth: true
        }
      },
      // Consulta rápida temporalmente desactivada.
      // {
      //   path: "/ProfileQuickReference/:cedula",
      //   name: "Profile",
      //   component: Profile,
      //   meta: {
      //     index: 1,
      //     icon: "home",
      //     requiresAuth: false,
      //     isMobile: false
      //   }
      // },
      {
        path: "/ProfileQuickReference/:cedula",
        redirect: "/login"
      },
      {
        path: "/login",
        name: "login",
        component: Login
      },
      {
        path: "/resumen-solicitud/:id",
        name: "Resumen solicitud",
        component: TramiteResumen,
        meta: {
          requiresAuth: true,
          invisible: true
        }
      },
      {
        path: "/nueva-solicitud",
        name: "nueva-solicitud",
        component: TramiteCreacion,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/solicitud-de-evaluacion-del-hogar",
        name: "solicitud-de-evaluacion-del-hogar",
        component: TramiteEvaluacion,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/create-account-options",
        name: "create-account-options",
        component: CreateAccountOptions
      },
      {
        path: "/access-options",
        name: "access-options",
        component: AccessOptions
      },
      {
        path: "/create-account-beneficiario",
        name: "create-account-beneficiario",
        component: CreateAccountBeneficario
      },
      {
        path: "/create-account-no-beneficiario",
        name: "create-account-no-beneficiario",
        component: CreateAccountNoBeneficario
      },
      {
        path: "/acceder",
        name: "acceder",
        component: Acceder
      },
      // {
      //   path: "/consultaRapida",
      //   name: "ConsultaRapida",
      //   component: ConsultaRapida
      // },
      {
        path: "/acceder-con-tarjeta-solidaridad",
        name: "acceder-con-tarjeta-solidaridad",
        component: AccederTarjetaSolidaridad
      },
      // {
      //   path: "/acceder-con-tarjeta-solidaridad",
      //   name: "acceder-con-tarjeta-solidaridad",
      //   component: AccederTarjetaSolidaridad
      // },
      {
        path: "/forgot-password",
        name: "forgot-password",
        component: ForgotPassword
      },
      {
        path: "/password-recovery/:userID",
        name: "password-recovery",
        component: PasswordRecovery
      },
      {
        path: "/user-config",
        name: "User config",
        component: UserConfig,
        meta: {
          requiresAuth: true,
          index: 2,
          icon: "cog",
          isMobile: true
        }
      }
    ];
  }

  static getMobileMenu(): RouteConfig[] {
    return this.getRoutes().filter((x) => {
      return x.meta && x.meta.isMobile;
   /*  }).sort((section1, section2) => {
      return section1.meta.index - section2.meta.index; */
    });
  }
}
const router = new Router({
  mode: "history",
  linkActiveClass: "is-active",
  base: process.env.BASE_URL,

  routes: RoutesList.getRoutes()
});
export default router;
